/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspacePermissionUpdate
 */
export interface WorkspacePermissionUpdate {
    /**
     * 
     * @type {ElementsUserReference}
     * @memberof WorkspacePermissionUpdate
     */
    user?: ElementsUserReference;
    /**
     * 
     * @type {ElementsGroupReference}
     * @memberof WorkspacePermissionUpdate
     */
    group?: ElementsGroupReference;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspacePermissionUpdate
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspacePermissionUpdate
     */
    workspace: number;
}

export function WorkspacePermissionUpdateFromJSON(json: any): WorkspacePermissionUpdate {
    return WorkspacePermissionUpdateFromJSONTyped(json, false);
}

export function WorkspacePermissionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacePermissionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : ElementsUserReferenceFromJSON(json['user']),
        'group': !exists(json, 'group') ? undefined : ElementsGroupReferenceFromJSON(json['group']),
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'workspace': json['workspace'],
    };
}

export function WorkspacePermissionUpdateToJSON(value?: WorkspacePermissionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ElementsUserReferenceToJSON(value.user),
        'group': ElementsGroupReferenceToJSON(value.group),
        'read_only': value.readOnly,
        'workspace': value.workspace,
    };
}


